import { queryOptions } from '@tanstack/react-query';
import { Acat, AcatAccountContraType, AcatTransferType } from '@orbis-systems/orbis-api-middleware';
import { orbisMiddleware, queryClient } from '@/queries/api';

export type InitiateAcatTransferParams = {
    accountNumber: string;
    type: AcatTransferType;
    contraAccount: string;
    contraAccountType: AcatAccountContraType;
    contraTitle: string;
    primaryTaxId: string;
    secondaryTaxId?: string;
    participantNumber: string;
    comment?: string;
    assets?: { symbol?: string; quantity: number; type?: string }[];
};

export const acatsQueries = {
    all: () => ['acats'] as const,
    branchList: () =>
        queryOptions<Acat[]>({
            queryKey: [...acatsQueries.all(), 'branch'],
            queryFn: () => orbisMiddleware.branch.getBranchAcatTransfer(),
        }),
    accountList: (accountId: number) =>
        queryOptions<Acat[]>({
            queryKey: [...acatsQueries.all(), 'account', accountId],
            queryFn: () => orbisMiddleware.account.getAcatTransfer(accountId),
        }),
};

export const acatsMutations = {
    initiate: ({ assets, ...params }: InitiateAcatTransferParams) =>
        orbisMiddleware.account.initiateAcatTransfer({
            ...params,
            assets: assets?.map(({ symbol, quantity }) => ({
                symbol: symbol ?? 'Cash(Funds)',
                quantity,
            })),
        }),
    cancel: (requestId: string) => orbisMiddleware.account.cancelAcatTransfer(requestId),
};

export function invalidateAcatsQueries() {
    return queryClient.invalidateQueries({ queryKey: acatsQueries.all() });
}
